/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/* eslint-disable react/no-danger */
import { MessageBar, Stack } from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { Announcement } from 'src/core/stores/UIConfigsStore';
import { Portal } from 'src/core/utils/routingUtils';

const shouldShowAnnouncement = (announcement: Announcement, portal: Portal) => {
    if (announcement.hidden) {
        return false;
    }

    if (portal.kind !== announcement.portal.kind) {
        return false;
    }

    if (portal.subPath !== announcement.portal.subPath) {
        return false;
    }

    return true;
};

/**
 * Displays banners for announcements added at run time through
 * Azure App Configuration Store.
 */
export const AnnouncementBanners = observer(() => {
    const { uiStore, dispatcher } = useGlobalState();

    const onDismissAnnouncementBanner = (index: number) => dispatcher.dispatch('dismissAnnouncementBanner', { index });

    return (
        <Stack id="announcementBannersContainer">
            {uiStore.announcements.map(
                (announcement, index) =>
                    shouldShowAnnouncement(announcement, uiStore.portal) && (
                        <MessageBar key={index} onDismiss={() => onDismissAnnouncementBanner(index)}>
                            <div dangerouslySetInnerHTML={{ __html: announcement.message }} />
                        </MessageBar>
                    )
            )}
        </Stack>
    );
});
